/**
 * Group chip color system
 *
 * Preset groups get fixed colors. Custom groups cycle through a rotation palette
 * indexed by group.id. Header filter chips remain uniform gray — different visual job.
 */

const PRESET_COLORS = {
  Friends: { bg: '#DEEEFF', text: '#3B6FA0' },
  'Close Friends': { bg: '#D4F5EC', text: '#2D7D6B' },
  Business: { bg: '#E5F2D8', text: '#5C7A42' },
  Family: { bg: '#EBE0FF', text: '#6B4FA0' },
};

const CUSTOM_ROTATION = [
  { bg: '#FFF0DB', text: '#9E7A35' },
  { bg: '#FFE0E8', text: '#A04B62' },
  { bg: '#E0F0F0', text: '#4A7878' },
  { bg: '#F5E6D0', text: '#8A6A42' },
];

/**
 * Get chip colors for a group.
 * @param {{ id: string, name: string, is_preset: boolean }} group
 * @returns {{ bg: string, text: string }}
 */
export function getGroupChipColor(group) {
  if (PRESET_COLORS[group.name]) {
    return PRESET_COLORS[group.name];
  }

  // Hash the UUID to a stable index — sum char codes for simplicity
  const hash = group.id.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return CUSTOM_ROTATION[hash % CUSTOM_ROTATION.length];
}
